export const RoleMap: {[key: string]:string}  = {
    'Admin': 'admin',
    'Practice Admin': 'practice_admin',
    'Dispatcher': 'dispatcher',
    'Provider': 'provider',
    'Agent': 'agent',
};

export function getRoleKeyByName(key:string) {
    return RoleMap[key];
}

export function getRoleNameByKey(key:string) {
    return Object.entries(RoleMap).find(k => k[1] == key)?.[0];
}